import React, { useEffect } from 'react'
import { EmailFormatWarning } from '@mc/authentication'
import { Button } from '@mc/design-system'
import {
  EmailAlreadyRegisteredWarning,
  EmailCaptureError,
  EmailCaptureForm,
  EmailCaptureInput,
  GdprCheckbox,
  useEmailCapture,
} from '@mc/email-capture'
import { EnhancedCtaCopy, usePrimaryCta } from '@mc/growth'
import { useTranslation } from '@mc/i18n'
import { EmailCaptureLegal } from '@mc/legal'
import { paths } from '@mc/paths'
import { PromoTermsLink, usePromotion } from '@mc/promo-utils'
import { EventTypes, getPageSource, Locations, track } from '@mc/track-event'
import { PROMO_I18N_NAMESPACE } from '../../../lib/constants'
import { trackCtaClicked } from '../../../lib/events'
import { setIsExplainerModalDismissed } from '../../../lib/helpers'

export const EmailCaptureContent = () => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const {
    isLoading,
    isError,
    isSuccess,
    isEmailRegistered,
    onCheckEmail,
    email,
  } = useEmailCapture()
  const { variables } = usePromotion()

  const { ctaCopy, ctaHref } = usePrimaryCta()

  useEffect(() => {
    if (isSuccess && email) {
      trackCtaClicked({
        action: ctaCopy,
        location: Locations.PROMOTION_MODAL,
        pageSource: getPageSource(),
        href: ctaHref,
      })
      setIsExplainerModalDismissed(variables?.promo_key as string)
      window.location.href = ctaHref
    }
  }, [isSuccess, email, ctaHref, ctaCopy, variables])

  return (
    <div>
      <div className='mc-mt-4 mc-mb-8'>
        <p>{t('common.description')}</p>

        <PromoTermsLink i18nKey='offerTerms.promoExplainerModal' />
      </div>

      <div>
        <EmailCaptureForm onSubmit={onCheckEmail}>
          <EmailCaptureInput className='mc-mb-5 mc-invert' required />

          <EmailFormatWarning
            pageSource={getPageSource()}
            trackProps={{
              location: Locations.PROMOTION_MODAL,
            }}
          />

          <GdprCheckbox className='mc-text--left mc-invert' />

          {isError && !isLoading && <EmailCaptureError className='mc-mb-2' />}

          {isEmailRegistered && !isLoading && (
            <EmailAlreadyRegisteredWarning
              redirectPath={paths.logIn(ctaHref)}
              onClick={(action: string) => {
                setIsExplainerModalDismissed(variables?.promo_key as string)
                track(EventTypes.MODAL_CLICKED, {
                  action,
                  location: Locations.PROMOTION_MODAL,
                  pageSource: getPageSource(),
                  href: ctaHref,
                })
              }}
            />
          )}

          <Button
            fullWidth
            className='mc-mb-3'
            type='submit'
            loading={isLoading}
          >
            <EnhancedCtaCopy>{ctaCopy}</EnhancedCtaCopy>
          </Button>

          <EmailCaptureLegal kind='submit' ctaText={ctaCopy} />
        </EmailCaptureForm>
      </div>
    </div>
  )
}
